document.documentElement.classList.remove('no-js');

// Reveal-on-scroll
(function(){
  var els=document.querySelectorAll('.reveal');
  if(!('IntersectionObserver' in window)||!els.length){els.forEach(function(el){el.classList.add('is-visible');});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target);}});},{threshold:0.12,rootMargin:'0px 0px -8% 0px'});
  els.forEach(function(el){io.observe(el);});
})();

// Product thumbnail swap
document.addEventListener('click',function(e){
  var t=e.target;
  if(t.matches('.product-thumbs img')){var m=document.querySelector('.product-main-img');if(m){m.src=t.src.replace('width=160','width=900');}}
});

// Intro water — once per session, never traps the user
(function(){
  var intro=document.getElementById('bluo-intro'); if(!intro) return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches, seen=false;
  try{seen=sessionStorage.getItem('bluo_intro_seen');}catch(e){}
  if(reduce||seen){ if(intro.parentNode) intro.parentNode.removeChild(intro); return; }
  try{sessionStorage.setItem('bluo_intro_seen','1');}catch(e){}
  window.setTimeout(function(){ if(intro.parentNode) intro.parentNode.removeChild(intro); },3000);
})();

// Interactive fluid hero — interaction energizes the background waves (no click rings)
(function(){
  var c=document.getElementById('heroCanvas'); if(!c) return;
  var ctx=c.getContext('2d');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DPR=Math.min(window.devicePixelRatio||1,2),W=1,H=1;
  function resize(){W=c.clientWidth||c.offsetWidth;H=c.clientHeight||c.offsetHeight;c.width=W*DPR;c.height=H*DPR;ctx.setTransform(DPR,0,0,DPR,0,0);}
  resize(); window.addEventListener('resize',resize);
  function base(){var g=ctx.createLinearGradient(0,0,W,H);g.addColorStop(0,'#0c2530');g.addColorStop(.55,'#0f3742');g.addColorStop(1,'#123f4c');ctx.fillStyle=g;ctx.fillRect(0,0,W,H);}
  if(reduce){base();return;}
  var t=0,energy=0,push=0,pushX=0,bubbles=[],lastMove=0;
  for(var i=0;i<16;i++)bubbles.push({x:Math.random(),y:Math.random(),s:Math.random()*1.6+.5,sp:Math.random()*.0006+.0002});
  function pos(e){var r=c.getBoundingClientRect(),p=e.touches?e.touches[0]:e;return{x:p.clientX-r.left,y:p.clientY-r.top};}
  c.addEventListener('pointermove',function(e){var n=performance.now();if(n-lastMove>30){lastMove=n;var p=pos(e);energy=Math.min(energy+0.045,1.1);push=Math.min(push+0.35,1.3);pushX=p.x;}});
  c.addEventListener('pointerdown',function(e){var p=pos(e);energy=Math.min(energy+0.6,1.6);push=1.5;pushX=p.x;});
  function draw(){
    energy*=0.985; push*=0.93;
    t+=0.006*(1+energy*1.7);
    base();
    ctx.globalCompositeOperation='lighter';
    for(var l=0;l<3;l++){
      ctx.beginPath();
      var amp=(22+l*12)*(1+energy*1.9), yb=H*(0.50+l*0.15), k=0.006+l*0.002, ph=t*(1+l*0.4);
      ctx.moveTo(0,H);
      for(var x=0;x<=W;x+=12){
        var d=x-pushX, local=push*70*Math.exp(-(d*d)/(2*130*130));
        var y=yb+Math.sin(x*k+ph)*amp+Math.sin(x*k*0.5+ph*1.3)*amp*0.5-local;
        ctx.lineTo(x,y);
      }
      ctx.lineTo(W,H); ctx.closePath();
      ctx.fillStyle='rgba(28,169,201,'+(0.05+l*0.02+energy*0.03)+')'; ctx.fill();
    }
    for(var bi=0;bi<bubbles.length;bi++){var b=bubbles[bi];b.y-=b.sp*(1+energy*1.5);if(b.y<-.05){b.y=1.05;b.x=Math.random();}ctx.beginPath();ctx.arc(b.x*W,b.y*H,b.s,0,6.2832);ctx.fillStyle='rgba(150,220,235,.14)';ctx.fill();}
    ctx.globalCompositeOperation='source-over';
    requestAnimationFrame(draw);
  }
  draw();
})();
